import { toArray, toId, toText } from './list';

const RESULTS = ['cumple', 'incumple', 'no_comprobado'];

function normalizeFinding(raw, index) {
    const result = RESULTS.includes(raw?.result) ? raw.result : 'no_comprobado';
    return {
        index: Number.isFinite(raw?.criterion_index) ? raw.criterion_index : index,
        criterion: toText(raw?.criterion ?? raw?.text, `Criterio ${index + 1}`),
        result,
        note: toText(raw?.note ?? raw?.comment),
    };
}

export function summarizeFindings(findings) {
    const summary = { cumple: 0, incumple: 0, no_comprobado: 0 };
    for (const item of findings) summary[item.result] += 1;
    return summary;
}

export function normalizeReviewRound(raw) {
    const findings = toArray(raw?.findings).map(normalizeFinding);
    const decision = raw?.decision;
    return {
        id: toId(raw?.id),
        taskId: toId(raw?.task_id),
        number: Number.isFinite(raw?.number) ? raw.number : null,
        state: raw?.state ?? null,
        isOpen: raw?.state === 'open',
        versioned: raw?.versioned === true,
        baseCommit: raw?.base_commit ?? null,
        deliveredCommit: raw?.delivered_commit ?? null,
        deliveredAt: raw?.delivered_at ?? null,
        deliveredBy: raw?.delivered_by ?? null,
        selfApproved: raw?.self_approved === true,
        findings,
        summary: raw?.summary && typeof raw.summary === 'object'
            ? { cumple: raw.summary.cumple ?? 0, incumple: raw.summary.incumple ?? 0, no_comprobado: raw.summary.no_comprobado ?? 0 }
            : summarizeFindings(findings),
        decision: decision ? {
            result: decision.result ?? null,
            reason: decision.reason ?? null,
            decidedAt: decision.decided_at ?? null,
            decidedBy: decision.decided_by ?? null,
        } : null,
    };
}
